import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { DirectionsIcon, Empty } from '@treams/treams-ui';

const Container = styled.div`
	width: 100%;

	> * {
		width: 100%;
		box-sizing: border-box;
	}
`;

export default function JourneyListEmptyState(props: { isViewer: boolean }): ReactElement {
	const { t } = useTranslation();

	return (
		<Container>
			<Empty.Card
				icon={<DirectionsIcon />}
				title={t(
					props.isViewer ? 'journey.list.emptyState.title' : 'journey.list.theirEmptyState.title',
				)}
			/>
		</Container>
	);
}
